import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { Widget, toWidget } from 'ckeditor5/src/widget';

export default class FontAwesomeEditing extends Plugin {
    static get pluginName() {
        return 'FontAwesomeEditing';
    }

    static get requires() {
        return [ Widget ];
    }

    constructor( editor ) {
        super( editor );

        // --- 1️⃣ Register model element ---
        //'fontColor', 'fontSize', 'fontWeight'
        editor.model.schema.register('faIcon', {
            allowWhere: '$text',
            allowAttributes: ['faIconClass', 'fontColor', 'fontBackgroundColor', 'fontSize' ],
            isInline: true,
            isObject: true,
            isSelectable: true,
        });

        // --- 2️⃣ Downcast: model -> view ---
        editor.conversion.for('dataDowncast').elementToElement({
            model: 'faIcon',
            view: (modelItem, { writer }) => {
                const iEl = writer.createEmptyElement('i', {
                    class: modelItem.getAttribute('faIconClass') || ''
                });
                writer.setCustomProperty('faIcon', true, iEl);
                return iEl;
            }
        });

        const fontAttributes = {
            'fontSize': 'font-size',
            'fontColor': 'color',
            'fontBackgroundColor': 'background-color'
        };

        editor.conversion.for('editingDowncast').elementToElement({
            model: 'faIcon',
            view: (modelItem, { writer }) => {
                const iEl = writer.createEmptyElement('i', {
                    class: modelItem.getAttribute('faIconClass') || ''
                });
                const sEl = writer.createContainerElement('span');
                writer.insert(writer.createPositionAt(sEl, 0), iEl);
                writer.setCustomProperty('faIcon', true, sEl);


                return toWidget(sEl, writer, { label: 'icon widget' });
            }
        });

        for (const [modelAttr, viewStyle] of Object.entries(fontAttributes)) {
            editor.conversion.for('editingDowncast').attributeToAttribute({
                model: {
                    name: 'faIcon',
                    key: modelAttr
                },
                view: (modelAttributeValue, {consumable}) => {
                    const cKey = 'attribute:' + modelAttr;
                    for (const c of consumable._consumable.values()) {
                        c.set(cKey, true);
                    }
                    return {
                        key: 'style',
                        value: {
                            [viewStyle]: modelAttributeValue
                        }
                    }
                }
            });
        }

        // --- 3️⃣ Upcast: view -> model ---
        editor.conversion.for('upcast').elementToElement({
            view: viewElement => {
                if (viewElement.is('element', 'i')) {
                    const classAttr = Array.from(viewElement.getClassNames()); // Set of classes
                    const faClass = classAttr.find(c => c.startsWith('fa') && c.includes('-'));
                    if (faClass) {
                        return { name: 'faIcon', faIconClass: classAttr.join(' ') };
                    }
                }
            },
            model: (viewElement, { writer }) => {
                const classAttr = Array.from(viewElement.getClassNames()).join(' ');
                return writer.createElement('faIcon', { faIconClass: classAttr });
            }

        });
    }
}